import { useState, useEffect, useRef, ReactNode, useCallback } from 'react';

import { ReactComponent as ActionIcon } from '../../assets/icons/action-icon.svg';

interface ListElement {
  icon?: JSX.Element;
  content: JSX.Element | string | Element;
  onClickFunc: (rowId?: string) => void;
  className?: string;
}

interface DropDownMenuProperties {
  dropDownList: ListElement[];
  dropDownIcon?: JSX.Element;
  rowId?: string | null;
  lineBetweenElement?: boolean;
}

/**
 * DropDown component
 */
function DropDownMenu(properties: DropDownMenuProperties) {
  const { dropDownList, dropDownIcon, rowId, lineBetweenElement } = properties;
  const reference = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState<boolean>(false);

  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (reference.current && !reference.current.contains(event.target as Node)) {
      setOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
  }, [reference]);

  return (
    <div className="drop-down">
      <div className="drop-down-title" onClick={() => setOpen(!open)} role="presentation">
        {dropDownIcon !== null ? (
          <span className="drop-down-icon">{dropDownIcon}</span>
        ) : (
          <div className="drop-down-default-icon">
            <ActionIcon />
          </div>
        )}
      </div>
      <div className={`drop-down-content ${open && 'open'}`} ref={reference}>
        {dropDownList.map((value) => (
          <div
            className={`drop-down-content-list-item ${lineBetweenElement && 'bottom-line'} ${value?.className && value.className}`}
            onClick={() => (rowId ? value.onClickFunc(rowId) : value.onClickFunc)}
            role="presentation">
            {value.icon && <span>{value.icon}</span>}
            <p>{value.content as ReactNode} </p>
          </div>
        ))}
      </div>
    </div>
  );
}

DropDownMenu.defaultProps = {
  dropDownIcon: null,
  rowId: null,
  lineBetweenElement: false,
};

export default DropDownMenu;
